import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import UnitTable from "../Tables/Maintable";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsExportData from "highcharts/modules/export-data";

HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);

// Basic Column chart options
const columnOptions = {
  chart: {
    type: "column",
  },
  title: {
    text: null,
  },
  xAxis: {
    categories: ["Alice Cooper", "Bob Smith", "Carol Johnson"],
  },
  yAxis: {
    min: 0,
    title: {
      text: "Count",
    },
  },
  series: [
    {
      name: "Total Duration",
      data: [55, 44, 55],
      pointWidh:50,
      color: "#70A7FA",
    },
    {
      name: "Avg.duration(per student)",
      data: [20, 30, 21],
      pointWidh:50,
      color: "#F7B072",
    },
  ],
  credits: {
    enabled: false,
  },
  exporting: {
    enable: true,
    chartOptions: {
      title: {
        text: 'Teacher Details',
      },
    },
  },

};

const IndividualUnitReport = () => {
  document.title = "Linc Quality Hub";
  const [singlebtn1, setSinglebtn1] = useState(false);
  const [singlebtn2, setSinglebtn2] = useState(false);
  const [singlebtn3, setSinglebtn3] = useState(false);
  const [singlebtn4, setSinglebtn4] = useState(false);
  const [customActiveTab, setcustomActiveTab] = useState("1");

  const location = useLocation();
  const navigate = useNavigate();

  const UnitName = location.state?.UnitName;

  const columns = [
    { field: "sno", headerName: "S.no", width: 100 },
    { field: "teachername", headerName: "Teacher Name", width: 300 },
    { field: "tstud", headerName: "Number of student", width: 280 },
    { field: "tduration", headerName: "Total duration", width: 250 },
    { field: "avgweek", headerName: "Avg.weekly engagement", width: 250 },
    {
      field: "avgdurstud",
      headerName: "Avg.duration(per student)",
      width: 250,
    },
    { field: "tsms", headerName: "Total Message", width: 250 },
  ];

  const rows = [
    {
      id: 1,
      sno: "1",
      teachername: "Alice Cooper",
      tduration: 55,
      avgweek: 25,
      avgdurstud: "20",
      tsms: 55,
      tstud: 3,
    },
    {
      id: 2,
      sno: "2",
      teachername: "Bob Smith",
      tduration: 44,
      avgweek: 25,
      avgdurstud: "30",
      tsms: 54,
      tstud: 6,
    },
    {
      id: 3,
      sno: "3",
      teachername: "Carol Johnson",
      tduration: 55,
      avgweek: 25,
      avgdurstud: "21",
      tsms: 5,
      tstud: 4,
    },
    // Add more rows as needed...
  ];

  const handleRowClick = (rowData) => {
    // Navigate to the desired page without passing in the URL
    navigate("/individalunitreport/unitstuddetails", { state: { studentID: rowData.id } });
  };
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content px-0">
        <Container fluid={true}>
          <div className="d-flex gap-2 align-items-center mb-2 ms-1">
            <Button onClick={() => navigate(-1)} className="mb-0 back-arrow-btn">
              <i className="fas fa-arrow-left"></i>
            </Button>{" "}
            <h3 className="bold">
              Teachers Deployed  Units  {UnitName || ""}</h3>
          </div>

          <div>

            <Card className="mb-2">

              <CardBody>

                <div>
                  <Row className="g-3">
                    <Col xl={12}>

                      <h5 className="f-16 bold mb-2">Teachers list</h5>
                      <UnitTable
                        columns={columns}
                        rows={rows}
                        onRowClick={handleRowClick}
                      />
                    </Col>
                  </Row>
                </div>
              </CardBody>
            </Card>
          </div>
          <Row className="g-2">
              {/* Basic Column Chart */}
              <Col lg={6} className="mb-2">
                <Card className="mb-2 h-100 border">
                  <CardBody>  
                    <h5 className="f-16 bold mb-3">Teacher Details</h5>
                    <HighchartsReact highcharts={Highcharts} options={columnOptions} />
                  </CardBody>
                </Card>
              </Col>
            </Row>  
        </Container>
      </div>
    </React.Fragment>
  );
};

export default IndividualUnitReport;
